import React, { useEffect, useState, useCallback } from 'react';
import { Box, Grid, Card, Typography, Avatar, IconButton, Container, Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { ChartSquare, CloseCircle, Logout, TickCircle } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticated } from '../auth/AuthContext';
import attendance from '../assets/images/demos/atten.png';
import helpDesk from '../assets/images/demos/Copilot_20250917_183223.png';
import policy from '../assets/images/demos/policy.png';
import cms from '../assets/images/demos/cms.png';
import image from '../assets/images/image.png';
import birthdayImage from '../assets/image.png';
import reimbursement from '../assets/images/demos/reimb.png';
import logo from '../assets/images/Coherent.png';
import nodata from '../assets/IMG_0916.JPG';
import { navigateToUrl } from 'single-spa';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import WishesCard from './Wishescard';

const microfrontends = [
  {
    id: 'attendance',
    title: 'Attendance',
    description: 'Mark and view your daily attendance efficiently.',
    route: '/angular/attendance/attendance-punch-in/attendance-punch-in',
    color: '#2196F3',
    icon: attendance
  },
  // {
  //   id: 'bug-tracker',
  //   title: 'Bug Tracker',
  //   description: 'Track, report, and manage software bugs quickly.',
  //   route: '/angular/bug/bug-tracker/bug-list',
  //   color: '#673AB7',
  //   icon: bugTracker
  // },
  // {
  //   id: 'timesheet',
  //   title: 'TimeSheet',
  //   description: 'Log and monitor work hours effortlessly.',
  //   route: '/angular/attendance/timeSheet/Timesheet-list',
  //   color: '#E91E63',
  //   icon: timeSheet
  // },
  {
    id: 'reimbursement',
    title: 'Reimbursement',
    description: 'Submit and track expense claims with ease.',
    route: '/angular/reimbursement/reimbursement-list',
    color: '#FFD600',
    icon: reimbursement
  },
  {
    id: 'helpdesk',
    title: 'Helpdesk',
    description: 'Manage support tickets and resolve issues fast.',
    route: '/chdPortal/dashboard',
    color: '#00B8D9',
    icon: helpDesk
  },
  {
    id: 'policy',
    title: 'Policy',
    description: 'Access and review company policies in one place.',
    route: '',
    color: '#5E35B1',
    icon: policy
  },
  {
    id: 'cms',
    title: 'CMS',
    description: 'Manage and publish content seamlessly across platforms.',
    route: '/angular/attendance/attendance-punch-in/attendance-punch-in',
    color: '#009688',
    icon: cms
  },
  {
    id: 'zentra',
    title: 'Zentra (Central Task Zone)',
    description: 'Manage and publish content seamlessly across platforms.',
    route: '/zentra-react/project/list',
    color: '#FF9800',
    icon: cms
  }
];

const Dashboard = () => {
  const navigate = useNavigate();
  const { logout, userRole } = useAuthenticated();
  const [user, setUser] = useState<any>({});
  const [officialData, setOfficialData] = useState<any>([]);
  const [birthdayData, setBirthdayData] = useState<any>([]);
  const [aniversaryData, setAniversaryData] = useState<any>([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [role, setRole] = useState(localStorage.getItem('roleName'));
  const [isLoading, setIsLoading] = useState(true);

  const handleMicrofrontendClick = (route: string, app: any) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const anyWindow = window as any;
    const accessToken = localStorage.getItem('accessToken') || '';
    const context = {
      launchedFrom: 'dashboard',
      launchedAt: new Date().toISOString(),
      userRole
    };
    console.log(app);
    if (app?.title === 'CMS') {
      localStorage.setItem('oneCoherentIsTrue', 'true');
    } else {
      localStorage.setItem('oneCoherentIsTrue', 'false');
    }
    if (typeof anyWindow.startMicrofrontends === 'function') {
      anyWindow.startMicrofrontends(route, { accessToken, context });
    } else {
      navigateToUrl(route);
    }
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const storedRole = localStorage.getItem('roleName');
      if (storedRole) {
        setRole(storedRole);
      }
    };

    // run once on mount
    handleStorageChange();

    // listen to storage changes (even from other tabs)
    window.addEventListener('storage', handleStorageChange);

    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleDialogOpen = () => {
    setDialogOpen(true);
    // handleClose();
  };
  const handleDialogClose = () => setDialogOpen(false);

  const handleLogoutConfirm = async () => {
    localStorage.clear();
    setDialogOpen(false);
    logout(navigate);
  };

  const getEmployeePersonalDetail = useCallback(async () => {
    const currentServiceToken = localStorage.getItem('accessToken');
    const cachedUser = localStorage.getItem('employeePersonalDetail');
    if (cachedUser) {
      setUser(JSON.parse(cachedUser));
      return;
    }
    try {
      const response = await axios.get(`https://cms-employee.coherent.in/employee/employeePersonalDetailsView`, {
        headers: { Authorization: `Bearer ${currentServiceToken}` }
      });
      if (response?.data) {
        const userData = response.data?.data?.employeePersonalDetailsViewDTOList[0];
        setUser(userData);
        localStorage.setItem('employeePersonalDetail', JSON.stringify(userData));
      } else {
        enqueueSnackbar('Login failed', { variant: 'error' });
      }
    } catch (error: any) {
      console.error('Login error:', error);
      enqueueSnackbar(error?.response?.data?.message || 'Login error occurred', {
        variant: 'error'
      });
    }
  }, []);

  const getEmployeeOfficialDetail = useCallback(async () => {
    const currentServiceToken = localStorage.getItem('accessToken');
    const cachedOfficial = localStorage.getItem('employeeOfficialDetail');
    if (cachedOfficial) {
      setOfficialData(JSON.parse(cachedOfficial));
      return;
    }
    try {
      const response = await axios.get(`https://cms-employee.coherent.in/employee/employeeOfficialDetailsView`, {
        headers: { Authorization: `Bearer ${currentServiceToken}` }
      });
      if (response?.data) {
        const officialData = response.data?.data[0];
        setOfficialData(officialData);
        localStorage.setItem('employeeOfficialDetail', JSON.stringify(officialData));
      } else {
        enqueueSnackbar('Login failed', { variant: 'error' });
      }
    } catch (error: any) {
      console.error('Login error:', error);
      enqueueSnackbar(error?.response?.data?.message || 'Login error occurred', {
        variant: 'error'
      });
    }
  }, []);

  const getEmployeeBirthdayDetail = useCallback(async () => {
    const currentServiceToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.get(`https://cms-master.coherent.in/accounting/getBrithDayDetails`, {
        headers: { Authorization: `Bearer ${currentServiceToken}` }
      });
      if (response?.data) {
        const officialData = response.data?.data;
        setBirthdayData(officialData);
      } else {
        enqueueSnackbar('Login failed', { variant: 'error' });
      }
    } catch (error: any) {
      console.error('Login error:', error);
      enqueueSnackbar(error?.response?.data?.message || 'Login error occurred', {
        variant: 'error'
      });
    }
  }, []);

  const getEmployeeAniversaryDetail = useCallback(async () => {
    const currentServiceToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.get(`https://cms-master.coherent.in/accounting/getAnniversaryDetails`, {
        headers: { Authorization: `Bearer ${currentServiceToken}` }
      });
      if (response?.data) {
        const officialData = response.data?.data;
        setAniversaryData(officialData);
      } else {
        enqueueSnackbar('Login failed', { variant: 'error' });
      }
    } catch (error: any) {
      console.error('Login error:', error);
      enqueueSnackbar(error?.response?.data?.message || 'Login error occurred', {
        variant: 'error'
      });
    }
  }, []);

  useEffect(() => {
    getEmployeeOfficialDetail();
    getEmployeePersonalDetail();

    const fetchWishes = async () => {
      try {
        setIsLoading(true);

        await Promise.all([getEmployeeBirthdayDetail(), getEmployeeAniversaryDetail()]);
      } catch (error) {
        console.error('Error fetching wishes:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWishes();

    if (!role) return; // wait until role is loaded
  }, [role, getEmployeeOfficialDetail, getEmployeePersonalDetail, getEmployeeBirthdayDetail, getEmployeeAniversaryDetail]); // runs again when role updates

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#fff',
        fontFamily: 'Poppins,sans-serif'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 4,
          py: 2,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: '#fff',
          borderBottom: '1px solid #eef0f5'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Logo */}
          <img src={logo} alt="Coherent Logo" style={{ width: '122px', height: 45 }} />
          {/* Dashboard menu text */}
          <ChartSquare size="20" color="#4E88ED" variant="Bulk" />

          <Typography
            sx={{
              fontSize: '0.875rem',
              lineHeight: '1.57',
              fontFamily: 'Poppins, sans-serif',
              color: '#4680FF',
              fontWeight: '500'
            }}
          >
            Dashboard
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ textAlign: 'right' }}>
            <Typography
              sx={{
                fontSize: '0.875rem',
                fontWeight: '600',
                lineHeight: '1.57',
                color: 'black'
              }}
            >
              {role === 'Admin' ? 'Admin' : user?.fullName}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: '400',
                lineHeight: '1.66',
                color: 'black'
              }}
            >
              {officialData?.employeeCode} | {officialData?.designation}
            </Typography>
          </Box>
          <Avatar
            src={
              user?.imageDTO?.image ? `data:${user?.imageDTO.imageType};base64,${user.imageDTO.image}` : '/default-avatar.png' // fallback image
            }
            sx={{ width: 40, height: 40 }}
          />
          <IconButton onClick={handleDialogOpen}>
            <Logout size={22} color="#1976d2" />
          </IconButton>
        </Box>
      </Box>

      {/* Card grid */}
      <Container disableGutters sx={{ py: 4, px: 3 }} maxWidth={false}>
        <WishesCard
          isHalf
          birthdayData={birthdayData}
          anniversaryData={aniversaryData}
          birthdayImage={birthdayImage}
          anniversaryImage={image}
          defaultImage={nodata}
          isLoading={isLoading}
        />

        <Grid container spacing={7}>
          {microfrontends.map((app) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={app?.id}>
              <Card
                onClick={() => handleMicrofrontendClick(app.route, app)}
                sx={{
                  borderRadius: 3,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  height: '100%', // ✅ let it stretch dynamically
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 24px rgba(0,0,0,0.15)'
                  }
                }}
              >
                {/* Main Row */}
                <Box sx={{ display: 'flex', flex: 1, minHeight: 170 }}>
                  {/* Left: Text */}
                  <Box
                    sx={{
                      flex: 1,
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center'
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '0.875rem',
                        lineHeight: '1.57',
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '600'
                      }}
                    >
                      {app.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '0.75rem',
                        lineHeight: '1.66',
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '400',
                        color: '#5B6B79'
                      }}
                    >
                      {app.description}
                    </Typography>
                  </Box>

                  {/* Right: Image */}
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Box
                      component="img"
                      src={app.icon}
                      alt={app.title}
                      sx={{
                        width: { xs: '70%', sm: '80%', md: '100%' }, // ✅ responsive scaling
                        height: 'auto',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Dialog
        open={dialogOpen}
        disableEscapeKeyDown
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            overflow: 'visible',
            borderRadius: 2,
            pt: 6,
            pb: 2,
            px: 3,
            textAlign: 'center',
            position: 'relative'
          }
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -28,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: '#fdeaea',
            width: 80,
            height: 80,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 3
          }}
        >
          <Logout size={42} variant="Bulk" color="#141313ff" />
        </Box>

        <DialogContent>
          <Typography sx={{ fontWeight: 'bold', fontSize: '1.1rem', mt: 1 }}>Are you sure you want to logout?</Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            onClick={handleDialogClose}
            startIcon={<CloseCircle variant="Bold" />}
            variant="outlined"
            color="secondary"
            sx={{
              minWidth: 100,
              borderRadius: 2,
              '&:hover': {
                transform: 'scale(1.05)'
              },
              transition: 'transform 0.2s ease-in-out'
            }}
          >
            No
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            startIcon={<TickCircle variant="Bold" />}
            variant="contained"
            color="error"
            sx={{
              minWidth: 100,
              borderRadius: 2,
              '&:hover': {
                transform: 'scale(1.05)'
              },
              transition: 'transform 0.2s ease-in-out'
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default Dashboard;
